import actionTypes from '@atom/actions/actionTypes';

import initialState from './initialState';

export default function workTemplatesView(
  state = initialState.workTemplatesView,
  action,
) {
  const { data, type } = action;
  switch (type) {
    case actionTypes.UPDATE_WORK_TEMPLATES_VIEW: {
      return { ...state, ...data };
    }
    default: {
      return state;
    }
  }
}
